import classNames from 'classnames'
import { format } from 'date-fns'
import { forwardRef } from 'react'
import { Button, ButtonIconPosition, Icon } from '@opallabs/lapidary'
import * as styles from './styles'
import type { DisplayProps } from './types'

export const TextDisplay = forwardRef<HTMLButtonElement, DisplayProps>(
  (
    {
      ariaLabel,
      buttonCss,
      buttonVariant = 'tertiary',
      className,
      dateDisplayFormat,
      disabled,
      htmlId,
      placeholder,
      selectedDate,
      /* eslint-disable @typescript-eslint/no-unused-vars --
         Used only for ButtonDisplay, but destructured so they are not
         splatted onto the Button with the Radix props: an undefined
         buttonText would override the date. */
      ariaLive,
      buttonText,
      iconPosition,
      showButtonText,
      /* eslint-enable @typescript-eslint/no-unused-vars */
      ...radixPopoverProps
    },
    ref
  ) => (
    <Button
      ariaLabel={ariaLabel}
      buttonText={
        selectedDate ? format(selectedDate, dateDisplayFormat) : placeholder
      }
      css={styles.textDisplay}
      disabled={disabled}
      id={htmlId}
      name="date-picker"
      styleOverrides={{ button: buttonCss }}
      ref={ref}
      className={classNames([
        styles.DatePickerStyleSelectors.root,
        className,
        { [styles.DatePickerStyleStates.hasValue]: Boolean(selectedDate) },
      ])}
      icon={<Icon glyph="gem-calendar" />}
      iconPosition={ButtonIconPosition.trailing}
      variant={buttonVariant}
      {...radixPopoverProps}
    />
  )
)

TextDisplay.displayName = 'Satellite: DatePicker ← TextDisplay'
